window.addEventListener('load', function(event) {
  // console.log('tabbed collections');

  const targetElement = document.querySelector('.ingredients');
  // Options for the Intersection Observer
  const options = {
    root: null, // Use the viewport as the root
    rootMargin: '0px', // Margin around the root
    threshold: 0.2 // Ratio of element's visibility needed to trigger callback
  };

  // Callback function to be executed when the element's visibility changes
  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        //console.log('Element is in the viewport');
        // Do something when the element enters the viewport
        document.querySelector('.ingredients__title').classList.add('ingredients__title--animate');
        
      } else {
        //console.log('Element is out of the viewport');
        // Do something when the element exits the viewport
        document.querySelector('.ingredients__title').classList.remove('ingredients__title--animate');
      }
    });
  }

  // Create the Intersection Observer instance
  const observer = new IntersectionObserver(handleIntersection, options);

  // Start observing the target element
  observer.observe(targetElement);
}, false);